import { getNewsPath } from '@dreamstack/feature-components/src/news/getNewsPath'
import { isValidNewsType } from '@dreamstack/feature-components/src/news/newsTypeUrls.static'
import { useLocale } from '@dreamstack/i18n'
import { assertPopulated } from '@dreamstack/payload/src/lib/assertPopulated'
import { NewsArticle } from '@dreamstack/payload/src/payload-types'
import { ArticleJsonLd } from 'next-seo'
import type { FunctionComponent } from 'react'

export const ArticleRichMarkup: FunctionComponent<
  React.PropsWithChildren<{
    article: NewsArticle
  }>
> = ({ article }) => {
  assertPopulated(article)
  assertPopulated(article.image)
  const { slug, newsType } = article
  const locale = useLocale()

  if (!slug || !newsType) return null
  if (!isValidNewsType(locale, newsType)) return null

  const url = getNewsPath({ locale, slug, newsType })

  return (
    <>
      <ArticleJsonLd
        mainEntityOfPage={{ id: url, type: 'WebPage' }}
        url={url}
        title={article.title ?? ''}
        images={article.image?.url ? [article.image?.url] : []}
        datePublished={article.date ?? article.updatedAt}
        authorName="Accentro"
        publisher={{
          type: 'Organization',
          name: 'Accentro GmbH',
        }}
        description={article.previewText ?? ''}
      />
    </>
  )
}
